
import {
  GET_RECENT_HOT_EVENT,
  SORT_RECENT_HOT_EVENT,
  COLLECT_RECENT_HOT_EVENT
} from '../mutiation'
import moment from 'moment'
import _ from 'lodash'

// initial state
// shape: [{ id, quantity }]
const state = {
  params: {
    type: 1,
    key: 'startTime',
    order: 1
  },
  list: []
}

// actions
const actions = {

}

// mutations
const mutations = {
  [GET_RECENT_HOT_EVENT] (state, data) {
    state.list = [...data.list]
    state.params = Object.assign({}, state.params, data.params)
  },
  [SORT_RECENT_HOT_EVENT] (state, params) {
    state.params = Object.assign({}, state.params, params)
  },
  [COLLECT_RECENT_HOT_EVENT] (state, data) {
    let item = data.item
    let status = data.status
    state.list = state.list.map(d => {
      if (d.eventId === item.eventId) {
        return Object.assign({}, d, {
          collectType: status
        })
      } else {
        return d
      }
    })
  }
}

const getters = {
  recentHotEventList: state => {
    let list = state.list.map(d => {
      return Object.assign({}, d, {
        time: moment(d.startTime).format('YYYY-MM-DD'),
        onlineTime: moment(d.onlineTime).format('YYYY-MM-DD'),
        imgUrl: d.imgUrl ? ('/app/' + d.imgUrl) : '/static/advanceImg.png'
      })
    })
    list = _.orderBy(list, state.params.key, state.params.order ? 'asc' : 'desc')
    let prediction = list.filter(d => d.type === 0)
    let online = list.filter(d => d.type === 1)
    return prediction.concat(online)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/pages/index/store/modules/recentHotEvent.js